<div class="mb-2 text-right">
  <!-- <button
    *ngIf="!showForm"
    id="saveBtn"
    i18n="@@TMRunButton"
    type="button"
    (click)="addCAPAS()"
    [style.background-color]="backgroundColorButton"
    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
    [style.background-color]="backgroundColorButton"
    style="padding: 0.3rem 1.6rem"
  >
    CAPA<em style="margin: 0 0 0 0.5rem" class="fas fa-plus-circle"></em>
  </button> -->
  		  <app-common-button
        *ngIf="!showForm"
          label=" CAPA"
          title=" CAPA "
          icon="fas fa-plus-circle"
          [buttonId]="1111"
			width="110px"
          [critical]="false"
          (clicked)="addCAPAS()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
</div>

<ag-grid-angular
  *ngIf="!showForm"
  class="ag-theme-balham"
  style="width: 100%; height: 300px"
  [rowData]="capas"
  [defaultColDef]="defaultColDef"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [pagination]="true"
  [paginationPageSize]="5"
  [enableBrowserTooltips]="true"
  (gridReady)="onGridReady($event)"
  [components]="components"
>
</ag-grid-angular>

<div *ngIf="showForm">
  <form [formGroup]="capaForm" class="deviation-form">
    <!-- Row 1 -->
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Name</mat-label>
        <input
          matInput
          placeholder="Enter CAPA Name "
          formControlName="capaName"
           [errorStateMatcher]="errorStateMatcher"
        />
        <mat-error *ngIf="capaForm.get('capaName')?.hasError('required')">
          Name of CAPA is required
        </mat-error>
        <!-- <mat-hint *ngIf="!rootCauseForm.get('rootCauseName')?.invalid">Max 200 chars</mat-hint> -->
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Action Type</mat-label>
        <mat-select formControlName="actionType"
         [errorStateMatcher]="errorStateMatcher">
          <mat-option *ngFor="let cT of actionType" [value]="cT.lookupvalue">
            {{ cT.lookupvalue }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="capaForm.get('actionType')?.hasError('required')">
          Action Type is required
        </mat-error>
      </mat-form-field>

      <!-- Due Date -->
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Due Date</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="dueDate"
           [errorStateMatcher]="errorStateMatcher"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>

        <mat-error *ngIf="capaForm.get('dueDate')?.hasError('required')">
          Due Date is required
        </mat-error>
      </mat-form-field>

    </div>

    <!-- Row 2 -->
    <div class="form-row two-column-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          formControlName="capaDescription"
          rows="4"
          placeholder="Describe the CAPA"
           [errorStateMatcher]="errorStateMatcher"
        ></textarea>
        <mat-error
          *ngIf="capaForm.get('capaDescription')?.hasError('required')"
        >
          Description is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="step-footer mt-2">
      <div class="footer-left">
      <!-- <button
        i18n="@@TMRunButton"
        type="button"
        [style.border-color]="backgroundColorButton"
        class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        (click)="cancelForm()"
        style="padding: 0.3rem 1.6rem"
        [style.border-color]="backgroundColorButton"
      >
        Cancel
      </button> -->

      		     <app-common-button
          label="Back"
          title="Back "  
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="cancelForm()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
      </div>

      <div class="footer-right">
      <!-- <button
        id="saveBtn"
        i18n="@@TMRunButton"
        type="button"
        [style.background-color]="backgroundColorButton"
        class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="backgroundColorButton"
        (click)="saveCapa()"
        style="padding: 0.3rem 1.6rem"
      >
        {{ isEditMode ? 'UPDATE' : 'ADD' }}
      </button> -->

      		<app-common-button
          label=" {{ isEditMode ? 'Update' : 'Add' }}"
          title=" {{ isEditMode ? 'Update' : 'Add' }} "
          [buttonId]="1111"
		      	width="110px"
          [critical]="false"
          (clicked)="saveCapa()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
    </div>

    </div>
  </form>
</div>
